"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.departmentStringArray = exports.DepartmentEnum = void 0;
var DepartmentEnum;
(function (DepartmentEnum) {
    DepartmentEnum[DepartmentEnum["FINANCE"] = 0] = "FINANCE";
    DepartmentEnum[DepartmentEnum["LEGAL"] = 1] = "LEGAL";
    DepartmentEnum[DepartmentEnum["ENGINEERING"] = 2] = "ENGINEERING";
    DepartmentEnum[DepartmentEnum["MARKETING"] = 3] = "MARKETING";
    DepartmentEnum[DepartmentEnum["HUMAN_RESOURCES"] = 4] = "HUMAN_RESOURCES";
    DepartmentEnum[DepartmentEnum["SALES"] = 5] = "SALES";
    DepartmentEnum[DepartmentEnum["DESIGN"] = 6] = "DESIGN";
    DepartmentEnum[DepartmentEnum["LOGISTICS"] = 7] = "LOGISTICS";
    DepartmentEnum[DepartmentEnum["PROCUREMENT"] = 8] = "PROCUREMENT";
    DepartmentEnum[DepartmentEnum["INTERNAL_AUDIT"] = 9] = "INTERNAL_AUDIT";
    DepartmentEnum[DepartmentEnum["BUSINESS_DEVELOPMENT"] = 10] = "BUSINESS_DEVELOPMENT";
    DepartmentEnum[DepartmentEnum["ADMINISTRATION"] = 11] = "ADMINISTRATION";
    DepartmentEnum[DepartmentEnum["PRODUCTION"] = 12] = "PRODUCTION";
    DepartmentEnum[DepartmentEnum["OPERATIONS"] = 13] = "OPERATIONS";
    DepartmentEnum[DepartmentEnum["MANAGEMENT"] = 14] = "MANAGEMENT";
    DepartmentEnum[DepartmentEnum["RD"] = 15] = "RD";
    DepartmentEnum[DepartmentEnum["CUSTOMER_SUPPORT"] = 16] = "CUSTOMER_SUPPORT";
    DepartmentEnum[DepartmentEnum["CONTROLLING"] = 17] = "CONTROLLING";
    DepartmentEnum[DepartmentEnum["QUALITY_MANAGEMENT"] = 18] = "QUALITY_MANAGEMENT";
})(DepartmentEnum || (exports.DepartmentEnum = DepartmentEnum = {}));
exports.departmentStringArray = [
    "Finance",
    "Legal",
    "Engineering",
    "Marketing",
    "Human Resources",
    "Sales",
    "Design",
    "Logistics",
    "Procurement",
    "Internal Audit",
    "Business Development",
    "Administration",
    "Production",
    "Operations",
    "Management",
    "R&D",
    "Customer Support",
    "Controlling",
    "Quality Management",
];
